<template>
	<div class="views">
		<div v-for="key in Object.keys(views)"
			 :key="`view-${key}`"
			 :class="{ active: view === key }"
			 @click="select(key)"
			 class="view">
			<div class="icon">
				<i :class="views[key].icon" />
			</div>

			<span class="view-label" v-text="views[key].label" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
.views {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;

	> div.view {
		display: flex;
		flex-direction: column;
		gap: 2px;
		color: #000;
		padding: 12px 20px;
		background-color: #eee;
		border-radius: 3px;

		cursor: pointer;
		user-select: none;

		&:hover {
			background-color: #ccc;
		}

		&.active {
			color: #fff;
			background-color: #f09ad6;
		}

		> div.icon {
			font-size: 18px;
		}

		> span.view-label {
			font-size: 12px;
			font-weight: 500;
		}
	}
}
</style>

<script>
export default {
	props: {
		view: {
		}
	},

	computed: {
		views() {
			return {
				default: {
					icon: 'far fa-list fa-fw',
					label: this.$t('linkedIn.ads.views.default')
				},
				branding: {
					icon: 'far fa-bullhorn fa-fw',
					label: this.$t('linkedIn.ads.views.branding')
				},
				video: {
					icon: 'far fa-play fa-fw',
					label: this.$t('linkedIn.ads.views.video')
				},
				conversions: {
					icon: 'far fa-mouse-pointer fa-fw',
					label: this.$t('linkedIn.ads.views.conversions')
				}
			}
		}
	},

	methods: {
		select(view) {
			this.$emit('view', view)
		}
	}
}
</script>
